import type { InputHTMLAttributes, PropsWithChildren } from 'react'

import { State } from '#/global/component/Form/State'
import type { InputState } from '#/global/component/Form/types'

type CheckboxProps = InputHTMLAttributes<HTMLInputElement>

interface Props extends Omit<CheckboxProps, 'onChange'> {
    isChecked?: boolean
    onChange?: (isChecked: boolean) => void
    state?: InputState
}

export const Checkbox = ({
    children,
    className,
    isChecked,
    onChange,
    state,
    style,
    ...props
}: PropsWithChildren<Props>) => {
    const { disabled } = props
    const handleChange: CheckboxProps['onChange'] = event => onChange?.(event.target.checked)

    const classNameList = ['dek-checkbox']
    state && classNameList.push(state.level)
    className && classNameList.push(className)

    return (
        <label className={classNameList.join(' ')} style={style}>
            <input
                checked={isChecked}
                onChange={handleChange}
                role="checkbox"
                type="checkbox"
                {...props}
            />
            <span className="dek-checkbox__check"></span>
            {children !== undefined && <span className="dek-checkbox__label">{children}</span>}
            {state && !disabled && state.message && <State state={state} />}
        </label>
    )
}
